export default __webpack_public_path__ + "static/media/gkhair.fba4c51a.JPG";